import React, { useState } from 'react';
import './projectCard.css';

function ProjectCard({data}) {
  const [hideData, setHideData] = useState(false);

  const handleMouseOver = () => {
    setHideData(true);
  }

  const handleMouseOut = () => {
    setHideData(false);
  }

  const display = {
    display: hideData ? 'none' : 'block',
   
    
  };
 
  function handleButtonClick (link) {
    console.log(window)
    window.open(link, '_blank');
  };
  // React Colors: Your go-to web app for creating and managing color palettes. Ideal for designers and developers with powerful customization features. Simplify your color work today!

  
  return (
    <>
<div className="container">
       <div class="column"  onMouseOver={handleMouseOver} onMouseOut={handleMouseOut} >
    <div class="post-module">
      <div class="thumbnail">
        <div>
          
        </div>
        <img className='img' src={data?.img} style={{
              height: '100%',
              width: '100%',
              objectFit: 'inherit', // Adjust this property based on your design preference
            }}/>
      </div>
      <div class="post-content">
        <div class="category" style={{
          background:'grey'
        }}>{data?.name}</div>
        <h1 class="title"> <a href={data?.demo} target='_blank'></a>{data.nama}</h1>
        {/* <h2 class="sub_title"></h2> */}
        <p class="description" style={display}><span>
          {data?.description}
            </span></p>
           

  
        <div className='btn-container'>
        <button class="project" role="button"><span class="text">Project</span><span  onClick={() => handleButtonClick(data?.demo)}><a target='_blank'>Link</a></span></button>
        <button class="github" role="button"><span class="text" >Github</span><span onClick={() => handleButtonClick(data?.github)}> <a  target='_blank'>Link</a></span></button>

        </div>
        
      </div>
    </div>
  </div>
</div>
</>
  );
}

export default ProjectCard;


